// extracted by mini-css-extract-plugin
export default {"title":"SideBarMain_title__o6P4y"};